<template>
  <div>
    <div class="timeRadio">
      <el-select
        v-model="values"
        placeholder="请选择"
        size="mini"
        style="width: 100px;display: flex;flex-direction: column;"
        @change="changeDate"
        :popper-append-to-body="false"
      >
        <el-option
          v-for="item in grayoptions"
          :key="item.value"
          :label="item.label"
          :value="item.value"
        >
        </el-option>
      </el-select>
      <el-radio-group v-model="radioVal" size="mini" @input="changeDate" style="margin-left: 6px;">
        <el-radio-button label="1">本月</el-radio-button>
        <el-radio-button label="2">本季度</el-radio-button>
        <el-radio-button label="3">本年</el-radio-button>
      </el-radio-group>
    </div>
    <div id="manageId"></div>
  </div>
</template>

<script>
import * as echarts from "echarts";
import moment from "moment";
import { getScore, getScoreData } from "@/api/morningMeet";
export default {
  name: "Statistical",
  data() {
    return {
      radioVal: "1",
      xAxisList: [],
      chartsData: [],
      myChart: "",
      grayoptions: [],
      values: ""
    };
  },
  mounted() {
    this.getScoreList();
    setTimeout(() => {
      this.initEcharts();
      this.changeDate();
    }, 500);
  },
  methods: {
    initEcharts() {
      var chartDom = document.getElementById("manageId");
      var chartsOption = {
        title: {
          text: "得分统计"
        },
        tooltip: {
          trigger: "axis",
          axisPointer: {
            type: "shadow"
          }
        },
        grid: {
          left: "3%",
          right: "4%",
          bottom: "3%",
          containLabel: true
        },
        xAxis: [
          {
            type: "category",
            data: this.xAxisList,
            axisTick: {
              alignWithLabel: true
            },
            axisLabel: {
              rotate: 20
            }
          }
        ],
        yAxis: [
          {
            type: "value",
            name: "（得分）"
          }
        ],
        series: [
          {
            name: "（得分）",
            type: "bar",
            barWidth: "60%",
            data: this.chartsData,
            showBackground: true,
            itemStyle: {
              color: new echarts.graphic.LinearGradient(0, 0, 0, 1, [
                { offset: 0, color: "#83bff6" },
                { offset: 0.5, color: "#188df0" },
                { offset: 1, color: "#188df0" }
              ])
            }
          }
        ]
      };
      this.myChart = echarts.init(chartDom);
      chartsOption && this.myChart.setOption(chartsOption);
    },
    async changeDate() {
      this.getScoreDataCharts();
    },
    async getScoreList() {
      const { code, data } = await getScore();
      if (code != 0) return;
      this.grayoptions = Object.entries(data).map(([value, key]) => ({
        label: key,
        value: value
      }));
      this.values = this.grayoptions[0].value
    },
    async getScoreDataCharts() {
      const params = {
        scoreItem:this.values,
        dateType:this.radioVal
      }
      const {code,data} = await getScoreData(params)
      if(code != 0) return
      this.xAxisList = data.map(item => (item.deptName))
      this.chartsData = data.map(item => (item.score))
      this.myChart.setOption({
        xAxis: [{ data: this.xAxisList }],
        series: [{ data: this.chartsData }]
      });
    }
  }
};
</script>

<style>
#manageId {
  width: 100%;
  height: 280px;
  /* height: 40%; */
}
.timeRadio {
  position: absolute;
  display: flex;

  right: 6%;
}
</style>



// WEBPACK FOOTER //
// src/components/MorningMeeting/GrayStatistical.vue